import React, { useContext } from 'react';

import FormData from './Form.context';
import Label from './Label.form';
import ErrorMsg from './ErrorMsg.form';

const Email = props => {
	const {
		required = false,
		name = 'email',
	} = props;

	const { register } = useContext(FormData);

	const reg = {
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Invalid email address',
    }
	};

	if (required)
		reg.required = 'Required';

	return (
		<div className='form-group-old'>
			<Label {...props} />

			<input
				name={name}
        ref={register(reg)}
			/>

			<ErrorMsg {...props} />
		</div>
	);
};

export default Email;
